// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import PoweredByFinerty from './PoweredByFinerty';

type SplashScreenProps = Readonly<{
  message?: string;
}>;

export function SplashScreen({ message = 'Verifying authorization...' }: SplashScreenProps) {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-lilac-05">
      {/* Center content */}
      <div className="flex flex-col items-center gap-8">
        {/* Brokerage logo from branding service */}
          <PoweredByFinerty />
        {/* Spinner */}
        <div className="relative w-10 h-10">
          <div className="absolute inset-0 rounded-full border-[3px] border-purple-primary/20" />
          <div className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-purple-primary animate-spin" />
        </div>

        {/* Status message */}
        <p className="text-purple-primary/70 text-sm font-medium tracking-wide font-sans">
          {message}
        </p>
      </div>

      {/* Powered by Finerty – bottom */}
      <div className="absolute bottom-8">
        <PoweredByFinerty />
      </div>
    </div>
  );
}
